import {styled} from "@mui/material/styles"
import {Checkbox, FormControlLabel, Skeleton} from "@mui/material"
import {HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT} from "../../../../config/constants"

export const CountWrapper = styled("span")`
    display: flex;
    margin-right: 1rem;
`

export const SingleFacetWrapper = styled("div")`
    display: flex;
    align-items: center;
    width: 100%;
    height: 2rem;
    font-family: ${({theme}) => theme.colours.components.inputLabel1.fontFamily};
    letter-spacing: ${({theme}) => theme.colours.components.inputLabel1.letterSpacing};

    a {
        display: flex;
        justify-content: space-between;
        text-decoration: none;
        font-size: ${({theme: {colours}}) => colours.typography.body2.fontSize};
        line-height: ${({theme}) => theme.colours.typography.body2.lineHeight};
        letter-spacing: ${({theme}) => theme.colours.typography.body2.letterSpacing};
        word-break: break-word;
        color: ${({theme}) => theme.colours.text.default};
        font-family: ${({theme}) => `${theme.colours.typography.body2.fontFamily}, ${theme.colours.font.default}`};
        font-weight: ${({theme}) => theme.colours.typography.body2.fontWeight};
        padding: 0.25rem 1rem;
    }

    a:hover {
        text-decoration: underline;
    }
`

export const FacetLabel = styled("span")`
    margin-right: 0.3rem;
    white-space: nowrap;
`

interface LabelProps {
    isFeatFacet: boolean
}

export const CheckboxLabelWrapper = styled("span")<LabelProps>`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    font-weight: ${({isFeatFacet, theme}) => (isFeatFacet ? 400 : theme.colours.font.primary.regular.weight)};
    font-family: ${({theme}) => theme.colours.typography.body2.fontFamily};
`

export const StyledFormControlLabel = styled(FormControlLabel)`
    margin: 0;
    width: 100%;
    margin-top: 0.0625rem;
    font-family: ${({theme}) => theme.colours.typography.body2.fontFamily};
`

export const TitleContainer = styled("span")`
    display: flex;
    align-items: center;
    letter-spacing: normal;
    margin-top: 0rem;

    text-transform: ${({theme}) => theme.colours.typography.body2.textTransform};
    font-weight: inherit;
    font-size: inherit;
    font-family: ${({theme}) =>
        `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`} !important; // This is to override MVC changes
`
interface FilterThumbnailProps {
    thumbnailSize?: string | null
    imageLoaded: boolean
}
export const FilterThumbnail = styled("img")<FilterThumbnailProps>`
    margin-right: 0.5rem;
    height: ${({thumbnailSize}) => (thumbnailSize === "large" ? "1.75rem" : "1.25rem")};
    width: ${({thumbnailSize}) => (thumbnailSize === "large" ? "1.75rem" : "1.25rem")};
    display: ${({imageLoaded}) => (imageLoaded ? "block" : "none")};
`

interface FacetCheckboxProps {
    $hasThumbnail: boolean
    $filterItemsCount: number
    $filterName: string
}
export const FacetCheckbox = styled(Checkbox, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<FacetCheckboxProps>`
    ${({$hasThumbnail}) => $hasThumbnail && `padding-right: 0.75rem;`}
    padding-left: ${({$filterItemsCount, $filterName}) =>
        $filterItemsCount !== HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT && $filterName === "feat" ? `0;` : `0.75rem;`}
    span {
        width: 1.25rem;
        height: 1.25rem;
    }
`

export const FilterThumbnailPlaceholder = styled(Skeleton)<FilterThumbnailProps>`
    height: ${({thumbnailSize}) => (thumbnailSize === "large" ? "1.5rem" : "1.25rem")};
    width: ${({thumbnailSize}) => (thumbnailSize === "large" ? "1.5rem" : "1.25rem")};
    margin-right: ${({thumbnailSize}) => (thumbnailSize === "large" ? "0.75rem" : "0.5rem")};
    display: ${({imageLoaded}) => (imageLoaded ? "none" : "block")};
`
